import { render, staticRenderFns } from "./ModalBio.vue?vue&type=template&id=7f38603e&scoped=true"
import script from "./ModalBio.vue?vue&type=script&lang=js"
export * from "./ModalBio.vue?vue&type=script&lang=js"
import style0 from "./ModalBio.vue?vue&type=style&index=0&id=7f38603e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f38603e",
  null
  
)

export default component.exports